module.exports = __webpack_public_path__ + "static/img/ad2.de66914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ad2.png
// module id = RkrE
// module chunks = 7